module.exports = __webpack_public_path__ + "img/incision-rebrand-comparison.2158c294.jpg";